<ion-input class="input" style="border: none;" [formControl]="formControl" [maxlength]="11" inputmode="number" diInputNoSpaces>
</ion-input>